import prescreening from '@/questionnaires/prescreening'
import recurring from '@/questionnaires/recurring'
import exitEN from '@/questionnaires/exit-en'
import exitDE from '@/questionnaires/exit-de'
export default {
  prescreening,
  recurring,
  exit: {
    en: exitEN,
    de: exitDE
  }
}
